import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './login.reducer';

export const LoginDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const loginEntity = useAppSelector(state => state.login.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="loginDetailsHeading">
          <Translate contentKey="crawlerBackendApp.login.detail.title">Login</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{loginEntity.id}</dd>
          <dt>
            <span id="username">
              <Translate contentKey="crawlerBackendApp.login.username">Username</Translate>
            </span>
          </dt>
          <dd>{loginEntity.username}</dd>
          <dt>
            <span id="role">
              <Translate contentKey="crawlerBackendApp.login.role">Role</Translate>
            </span>
          </dt>
          <dd>{loginEntity.role}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.login.customer">Customer</Translate>
          </dt>
          <dd>{loginEntity.customer ? loginEntity.customer.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/login" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/login/${loginEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LoginDetail;
